<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <v-data-table
      :headers="headers"
      :items="merchants"
      item-key="nmid"
      :options.sync="options"
      :server-items-length="totalMerchants"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="rowClass"
      class="d-print-table"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50],
        // showFirstLastPage: true,
      }"
      sort-by="id"
      fixed-header
      :style="{ padding: '10px', height: '70vh' }"
    >
      <template v-slot:[`body.prepend`]>
        <tr>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.merchant_name"
              type="text"
              label="Nama Merchant"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.mid"
              type="text"
              label="MID"
              v-on:keyup.enter="getData"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
            />
          </td>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
        </tr>
      </template>
      <template v-slot:top>
        <v-toolbar flat>
          <v-spacer />
          <template>
            <v-btn
              color="warning"
              class="mb-2"
              @click="getData"
              :loading="loading"
              :disabled="loading"
              :style="{
                cursor: 'pointer',
                'margin-right': '10px',
              }"
              ><v-icon>mdi-restart</v-icon
              ><template v-slot:loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
            </v-btn>
            <v-menu
              offset-y
              rounded="lg"
              transition="slide-y-transition"
              bottom
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="warning"
                  class="mb-2"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon light size="20">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  link
                  to="/maintenance-settlement/update-maintenance-settlement/bulk-upload"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-cloud-upload</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Bulk Upload Update</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:item="{ item, index }">
        <tr
          :key="index"
          :style="{ cursor: 'pointer' }"
          :class="selectedRow == index ? 'indigo lighten-5' : ''"
          @click="selectRow(index)"
        >
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ (options.page - 1) * options.itemsPerPage + index + 1 }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.merchant_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.mid }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.nmid }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.account_number }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.address }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.merchant_criteria }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.email }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.mobile_phone }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            {{ item.qr_type_name }}
          </td>
          <td class="d-block d-sm-table-cell d-print-table-cell">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="clearSearch"> Reset </v-btn>
      </template>
    </v-data-table>

    <edit-maintenance-settlement
      :dialogMS="dialog"
      :editedItem="editedItem"
      :editedIndex="editedIndex"
      v-on:closeCancelParent="close"
    />
  </v-card>
</template>

<script>
import { date } from '../../lib/helpers';

export default {
  components: {
    editMaintenanceSettlement: () =>
      import('../../components/form/EditMaintenanceSettlement.vue'),
  },
  data: () => ({
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: 'No',
        align: 'start',
        value: 'id',
        width: '10',
        sortable: false,
      },
      {
        text: 'Nama Merchant',
        value: 'merchant_name',
        width: '150',
        align: 'center',
      },
      {
        text: 'MID',
        value: 'mid',
        width: '150',
        align: 'center',
      },
      {
        text: 'NMID',
        value: 'nmid',
        width: '150',
        align: 'center',
      },
      {
        text: 'No Rekening',
        value: 'account_number',
        width: '150',
        align: 'center',
      },
      {
        text: 'Alamat Lengkap',
        value: 'address',
        width: '250',
        align: 'center',
      },
      {
        text: 'Kriteria Merchant',
        value: 'merchant_criteria',
        width: '150',
        align: 'center',
      },
      {
        text: 'Email',
        value: 'email',
        width: '150',
        align: 'center',
      },
      {
        text: 'No. Handphone',
        value: 'mobile_phone',
        width: '150',
        align: 'center',
      },
      {
        text: 'Jenis QR',
        value: 'qr_type_name',
        width: '150',
        align: 'center',
      },
      {
        text: 'Action',
        value: 'actions',
        align: 'center',
        width: '50',
        sortable: false,
      },
    ],
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},
    search: {
      merchant_name: '',
      mid: '',
    },
    selectedRow: '',
  }),

  computed: {
    flashErrorMessage() {
      return this.$store.state.maintenanceSettlement.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.maintenanceSettlement.flashError;
      },
      set() {
        this.$store.commit('maintenanceSettlement/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.maintenanceSettlement.errors;
    },
    loading() {
      return this.$store.state.maintenanceSettlement.loading;
    },
    merchants() {
      return this.$store.state.maintenanceSettlement.allMerchants;
    },
    totalMerchants() {
      return this.$store.state.maintenanceSettlement.totalMerchants;
    },
    totalPage() {
      return this.$store.state.maintenanceSettlement.totalPage;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
    show() {
      if (!this.show) {
        this.clearSearch();
      }
    },
  },

  async mounted() {
    this.$store.commit('maintenanceSettlement/clearMerchants');
  },

  methods: {
    selectRow(index) {
      if (this.selectedRow != index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.merchant_name = '';
      this.search.mid = '';
      this.$nextTick(() => {
        this.getData();
      });
    },

    getData() {
      this.$store.commit('maintenanceSettlement/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('maintenanceSettlement/fetchMerchants', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          merchantId: null,
          action: 'merchant',
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage == 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    editItem(item) {
      const newItem = { ...item, resettlement: { id: item.id } };
      this.editedIndex =
        this.$store.state.maintenanceSettlement.allMerchants.indexOf(item);
      this.editedItem = { ...newItem };
      this.dialog = true;
    },

    close() {
      this.dialog = false;

      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
    },
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
@media only screen and (min-width: 600px) {
  .fixed-row {
    position: -webkit-sticky;
    position: sticky;
    top: 48px;
    z-index: 1;
    background-color: white;
  }
}
</style>
